












import { createComponent, SetupContext } from "@vue/composition-api";

import SupportCenter from "@/components/templates/Common/SupportCenter.vue";

const gravBaseUrl = process.env.VUE_APP_GRAV_BASE_URL;

export default createComponent({
  setup(props: {}, context: SetupContext) {
    return {
      gravBaseUrl
    };
  },
  components: {
    SupportCenter
  }
});
